<script setup>
import { ref, reactive, onMounted, nextTick, watch, computed } from "vue";
import { CountTo } from "vue3-count-to";
import { activityEnum } from "@/enum/activityEnum.js";
import { activitySignOrderStateEnum } from "@/enum/activitySignOrderStateEnum.js";
import { certificateTypeEnum } from "@/enum/certificateTypeEnum.js";
import router from "@/router/index.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import YTTag from "@/components/YTTag/index.vue";
import BoxUpload from "@/components/YTBoxUpload/newIndexNewApi.vue";
// import BoxUpload from "@/components/YTBoxUpload/newIndex.vue";
import YTActivitySignOrderState from "@/components/YTActivitySignOrderState/index.vue";
import {
  changeClubActivityState,
  detailClubActivityNew,
  getActivityStatistics,
  listClubActivity,
  listClubActivityParticipantNew,
  activity_album_save,
  api_collectActivityPhoto,
  api_cancelCollectActivityPhoto,
  api_getAlbum,
} from "@/api/club/club.js";
import YTActivityState from "@/components/YTActivitySaleState/index.vue";
import { Close } from "@element-plus/icons-vue";
import YTCard from "@/components/YTCard/newIndex.vue";
import YTAddress from "@/components/YTAddress/newIndex.vue";
import YTGender from "@/components/YTGender/index.vue";
import YTDialog from "@/components/YTDialog/index.vue";
import { debounceFn } from "@/hooks/debounce.js";
import moment from "moment";
import { userTokenStore, userInfoStore } from "@/store/store.js";
import axios from "axios";
import { editActivityState } from "@/api/virtualGoods/virtualGoods.js";
import { formatTags } from "@/hooks/tag.js";
import { shortNumberFormat } from "@/hooks/numberUtils.js";
import YTTab from "@/components/YTTab/index.vue";

// 用户信息
const userInfo = userInfoStore().info

/*初次加载*/
onMounted(async () => {
  await handleSearch();
  await handleGetData();
});

const cancel_albumImageIndex = ref(0);
const cancel_collect_show = ref(false);

const tabs_list = reactive([
  {
    id: 0,
    title: "报名人员信息",
    show: true,
  },
  {
    id: 1,
    title: "活动介绍",
    show: true,
  },
  {
    id: 2,
    title: "活动相册",
    show: true,
  },
]);
const tab_selected = ref(0);

/*统计数据相关功能*/
// 统计数据
const statisticsData = reactive({
  total: 0,
  thisYearTotal: 0,
  thisMonthTotal: 0,
  underWayTotal: 0,
});
// 处理获取统计数据
const handleGetData = async () => {
  try {
    loading.value = true;
    const res = await getActivityStatistics();
    statisticsData.total = parseInt(res.total);
    statisticsData.thisYearTotal = parseInt(res.thisYearTotal);
    statisticsData.thisMonthTotal = parseInt(res.thisMonthTotal);
    statisticsData.underWayTotal = parseInt(res.underWayTotal);
    loading.value = false;
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};

/*过滤器相关功能*/
// 省市区级联选择器锚点
const YTAddressRef = ref();
// 活动状态枚举
const activityStateOption = ref(activityEnum);
// 过滤器表单
const formData = reactive({
  name: null,
  city: null,
  activityStateList: [],
});
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === "btnSearch") YTTablePaginationRef.value.resetPage();
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize(),
    });
    loading.value = true;
    // 处理时间
    // formData.startTime = formData.activityTime[0] ? moment(formData.activityTime[0]).format("YYYY-MM-DD") : null;
    // formData.endTime = formData.activityTime[1] ? moment(formData.activityTime[1]).format("YYYY-MM-DD") : null;
    // 搜索实物商品
    const res = await listClubActivity(param.value, formData);
    tableData.value = [];
    tableData.value = res.list;
    console.log("tableData", tableData.value);
    total.value = parseInt(res.total);
    loading.value = false;
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};
// 清空表单内容
const handleReset = () => {
  formData.name = null;
  formData.city = null;
  YTAddressRef.value.cleanSelect();
  formData.activityStateList = [];
  handleSearch("btnSearch");
};
// 处理选择所属区域
const handleSelectAddress = (data) => {
  formData.city = data.value.at(-1);
};

/*表格相关功能*/
// 表格加载状态
const loading = ref(false);
// 表格数据
const tableData = ref([]);
// 表格数据总条数
const total = ref(0);
// 翻页组件锚点
const YTTablePaginationRef = ref();
const selected_act_id = ref(null);
// 处理翻页
const handleChangePage = () => {
  handleSearch();
};
// 获取活动详情
const getDetail = async (item) => {
  try {
    console.log("item", item);
    selected_act_id.value = item.goodsId;
    drawer.value = true;
    drawerLoading.value = true;
    drawerCache.value = await detailClubActivityNew(item.goodsId);
    if (drawerCache.value?.description) {
      drawerCache.value.description = drawerCache.value.description.replace(
          /<img[^>]*>/g,
          (match) =>
              match.replace(
                  />$/,
                  ' style="width:100%;height:auto;object-fit:contain;" />'
              )
      );
    }
    if (drawerCache.value?.descriptionEn) {
      drawerCache.value.descriptionEn = drawerCache.value.descriptionEn.replace(
          /<img[^>]*>/g,
          (match) =>
              match.replace(
                  />$/,
                  ' style="width:100%;height:auto;object-fit:contain;" />'
              )
      );
    }
    // 同步相册查询所需的goodsId，并重置分页为第一页
    album_params.query_params.goodsId = item.goodsId;
    albumPaginationRef.value?.resetPage();
    album_params.page_params.pageNum = 1;
    tabs_list[2].show = drawerCache.value.activityInfo.hasAlbum;
    activityState.value = drawerCache.value.activityInfo.activityState;
    drawerLoading.value = false;
    nextTick(async () => {
      await handleGetParticipantList();
      await getAlbum();
    });
  } catch (e) {
    console.log(e);
    drawerLoading.value = false;
  }
};
// 右弹出抽屉表格加载状态
const drawerTableLoading = ref(false);
// 证件类型枚举
const certificateType = ref(certificateTypeEnum);
// 右弹出抽屉列表翻页锚点
const YTTablePaginationDrawerRef = ref();
// 右弹出抽屉列表总条数
const totalDrawer = ref(0);
// 处理获取活动详情报名人员列表
const handleGetParticipantList = async (mode = "init") => {
  if (mode === "btnSearch") YTTablePaginationDrawerRef.value.resetPage();
  // 组件弹出需要时间，所以使用nextTick
  await nextTick(async () => {
    try {
      drawerTableLoading.value = true;
      let pageInfo = {
        page: YTTablePaginationDrawerRef.value.getPage(),
        pageSize: YTTablePaginationDrawerRef.value.getPageSize(),
      };
      let param = {
        goodsId: drawerCache.value.goodsId,
        orderStateList: selectedIds.value,
      };
      const res = await listClubActivityParticipantNew(pageInfo, param);
      console.log("res", res.list);
      drawerTableData.value = [];
      setTimeout(() => {
        drawerTableData.value = res.list;
        totalDrawer.value = parseInt(res.total);
        drawerTableLoading.value = false;
      }, 0);
    } catch (e) {
      console.log(e);
      drawerTableLoading.value = false;
    }
  });
};
// 右弹出抽屉打开状态
const drawer = ref(false);
// 右弹出抽屉加载状态
const drawerLoading = ref(false);
// 右弹出抽屉表格数据
const drawerTableData = ref([]);
// 右弹出抽屉缓存信息
const drawerCache = ref({
  activityInfo: {
    activityState: null,
  },
  goodsName: null,
  goodsId: null,
  images: [],
  description: null,
});
// 处理右弹出抽屉关闭
const handleCloseDrawer = () => {
  if (img_edit.value) {
    ElMessage.error("请先取消编辑");
    return;
  }
  console.log("run in handleCloseDrawer");
  YTTablePaginationDrawerRef.value?.resetPage();
  drawerCache.value = {
    activityInfo: {
      activityState: null,
    },
    goodsName: null,
    goodsId: null,
    images: [],
    description: null,
  };
  drawer.value = false;
  activityState.value = null;
  tab_selected.value = 0;
};
// 处理右弹出抽屉翻页
const handleDrawerPageChange = () => {
  handleGetParticipantList();
};
// 活动报名状态枚举
const activityState = activitySignOrderStateEnum;
// 已选中的报名状态Id
const selectedIds = ref([]);
// 处理表头过滤的报名状态改变
const handleSignStateChange = debounceFn((ids) => {
  console.log("触发请求，已选中:", ids);
  handleGetParticipantList("btnSearch");
}, 800);
// 处理公开返回枚举转换文本
const handleVisibilityType = (type) => {
  let res = "未知状态";
  if (type === "PUBLIC") {
    res = "公开";
  } else if (type === "MEMBER_VISIBLE") {
    res = "会员可见";
  } else if (type === "SPECIFIED_USER") {
    res = "指定用户可见";
  }
  return res;
};
// 监听已选中的报名状态Id
watch(
  selectedIds,
  (newVal) => {
    handleSignStateChange([...newVal]);
  },
  { deep: true }
);
// 处理弹窗表头选择报名状态过滤条件
const handleSelectSignStateFilter = (item) => {
  const index = selectedIds.value.findIndex((i) => i === item.stateId);
  console.log("index", index);
  if (index === -1) {
    selectedIds.value.push(item.stateId);
  } else {
    selectedIds.value.splice(index, 1);
  }
};
// 处理下载活动已报名人员名单
const handleDownloadSignedUpActivityUser = async (item) => {
  ElMessage.warning("下载中...");
  if (userInfo.hasActivityRegisterExtraInfo) {
    await downloadFile(
        `${
            import.meta.env.VITE_API_URL
        }/clubActivity/download/participant/extraInfo?activityId=${
            item.goodsId
        }&orderState=REGISTERED`,
        {}, // 请求体数据
        `${item.goodsName}已报名人员名单-${moment().format(
            "YYYY-MM-DD_HHmmss"
        )}.csv` // 默认文件名
    );
  } else {
    await downloadFile(
        `${
            import.meta.env.VITE_API_URL
        }/clubActivity/download/participant?activityId=${
            item.goodsId
        }&orderState=REGISTERED`,
        {}, // 请求体数据
        `${item.goodsName}已报名人员名单-${moment().format(
            "YYYY-MM-DD_HHmmss"
        )}.csv` // 默认文件名
    );
  }
};
/**
 * 自定义文件名的下载函数
 * @param {string} url - 完整接口URL
 * @param {Object} requestData - 请求体数据
 * @param {string} customFilename - 自定义文件名
 */
const downloadFile = async (url, requestData = {}, customFilename) => {
  try {
    const token = userTokenStore().token;
    const response = await axios.post(url, requestData, {
      responseType: "blob",
      headers: {
        Authorization: token.tokenValue,
        "Login-Type": token.loginType,
        "Content-Type": "application/json",
      },
    });

    // 创建下载链接
    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", customFilename); // 使用传入的自定义文件名
    document.body.appendChild(link);
    link.click();

    // 清理
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);

    return true;
  } catch (error) {
    console.error("文件下载失败:", error);
    ElMessage.error("文件下载失败");
    return false;
  }
};
// 处理活动状态改变
const handleChangeState = async (state) => {
  console.log("state", state);
  await ElMessageBox.confirm("确定修改活动状态?", "警告", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    confirmButtonClass: "confirmBtn",
    cancelButtonClass: "cancelBtn",
    type: "warning",
  })
    .then(async () => {
      console.log("确定修改活动状态，即将发起接口");
      activityState.value = state;
      let param = {
        goodsId: drawerCache.value.goodsId,
        activityState: activityState.value,
      };
      console.log("param", param);
      await editActivityState(param);
      await getDetail({ goodsId: param.goodsId });
      ElMessage({
        type: "success",
        message: "修改成功",
      });
      await handleSearch();
    })
    .catch(async (e) => {
      console.log("取消修改活动状态", e);
      await getDetail({ goodsId: drawerCache.value.goodsId });
      ElMessage({
        type: "info",
        message: "取消修改",
      });
    });
};
// 当前激活态的tabs
const activeName = ref("first");
// 处理点击tabs切换
const handleClickTabs = (tab, event) => {
  // 预留给特殊情况做处理
  console.log("click", tab, event);
};

/*操作栏功能*/
// 发布
const setSale = async (item) => {
  const param = {
    goodsId: item.goodsId,
    state: 1,
  };
  try {
    await changeClubActivityState(param);
    ElMessage.success("发布成功");
    await handleSearch();
  } catch (e) {
    console.log(e);
  }
};
// 下架
const setUnSale = async (item) => {
  const param = {
    goodsId: item.goodsId,
    state: 0,
  };
  try {
    await changeClubActivityState(param);
    ElMessage.success("下架成功");
    await handleSearch();
  } catch (e) {
    console.log(e);
  }
};
// 处理编辑活动
const handleEdit = (item) => {
  router.push({ path: "/store/editActivity", query: { goodsId: item.goodsId } });
};

// 相册功能 ===========================
const album_loading = ref(false);
// 照片预览
const dialogVisible = ref(false);
const dialogImageUrl = ref("");
// 照片编辑
const img_edit = ref(false);
const albumDraft = ref([]);
// 保存原始状态，用于取消编辑时恢复
const originalAlbumImages = ref([]);
const originalAlbumImageInfos = ref([]);
// 照片收藏
const img_collect = ref([]);
const album_list = reactive([]);
const album_params = reactive({
  page_params: {
    pageNum: 1,
    pageSize: 54,
  },
  query_params: {
    goodsId: drawerCache.value.goodsId,
    storeId: userInfoStore().info.storeId,
  },
});
const album_total = ref(0);
const albumPaginationRef = ref();
// 获取当前页某一项的图片信息（含收藏状态等）
const getAlbumImageInfo = (item) => {
  // 如果 item 是对象，直接返回；如果是字符串，则查找匹配的项
  if (typeof item === "object" && item !== null) {
    return item;
  }
  return (
    album_list.find((albumItem) => albumItem.originAlbumImage === item) || {}
  );
};
// 获取相册照片
const getAlbum = async () => {
  try {
    album_loading.value = true;
    const res = await api_getAlbum(
      album_params.page_params,
      album_params.query_params
    );
    res.list.map((item) => {
      item.thumbnailAlbumImage_20 = `${item.originAlbumImage}?x-oss-process=image/resize,p_20`;
    });
    album_list.length = 0; // 清空数组
    album_list.push(...res.list); // 添加新元素
    album_total.value = res.total || 0; // 设置总数
    album_loading.value = false;
  } catch (error) {
    console.log("getAlbum error: ", error);
    album_loading.value = false;
  }
};
// 相册列表分页事件处理
const handleAlbumPageChange = () => {
  album_params.page_params.pageNum = albumPaginationRef.value.getPage();
  album_params.page_params.pageSize = albumPaginationRef.value.getPageSize();
  getAlbum();
};

// 上传失败
const handlePicFail = () => {
  album_loading.value = false;
};
// 上传中
const handlePicProgress = () => {
  album_loading.value = true;
};
// 上传成功
const handlePicSuccess = async (photo_arr) => {
  try {
    const album_list = [
      ...(drawerCache.value.activityInfo.albumImages || []),
      ...photo_arr,
    ];
    const body_params = ref({
      goodsId: selected_act_id.value,
      albumImages: album_list,
    });
    await activity_album_save(body_params.value);
    const res2 = await detailClubActivityNew(selected_act_id.value);
    drawerCache.value = res2;
    album_loading.value = false;

    // 重新获取当前页数据以显示新上传的照片
    getAlbum();
  } catch (err) {
    console.log(err);
    album_loading.value = false;
  }
};

const showPreview = (item) => {
  dialogImageUrl.value = item.originAlbumImage;
  dialogVisible.value = true;
};

const startAlbumEdit = () => {
  img_edit.value = true;
  // 保存原始状态，用于取消编辑时恢复
  originalAlbumImages.value = [
    ...(drawerCache.value.activityInfo.albumImages || []),
  ];
  originalAlbumImageInfos.value = [
    ...(drawerCache.value.activityInfo.albumImageInfos || []),
  ];

  // 设置编辑草稿 - 只使用当前页的图片数据
  albumDraft.value = [...album_list];
};

const cancel_finishAlbum = () => {
  // 取消编辑时，还原图片列表和收藏状态为原始状态
  drawerCache.value.activityInfo.albumImages = [...originalAlbumImages.value];
  drawerCache.value.activityInfo.albumImageInfos = [
    ...originalAlbumImageInfos.value,
  ];
  img_edit.value = false;

  // 重新获取当前页数据以显示原始状态
  getAlbum();
};

const deleteAlbumImage = (item) => {
  // 找到要删除的图片在 albumDraft 中的索引
  // 现在 albumDraft 包含完整的图片对象，需要比较 originAlbumImage 属性
  const index = albumDraft.value.findIndex(
    (draftItem) => draftItem.originAlbumImage === item.originAlbumImage
  );
  if (index !== -1) {
    // 删除图片的同时也需要删除对应的收藏状态信息
    albumDraft.value.splice(index, 1);

    // 同步更新albumImageInfos，确保收藏状态与图片一一对应
    if (drawerCache.value.activityInfo.albumImageInfos) {
      drawerCache.value.activityInfo.albumImageInfos.splice(index, 1);
    }
  }
};

const isSameArrayIgnoreOrder = (a = [], b = []) => {
  if (a.length !== b.length) return false;
  const ma = new Map(),
    mb = new Map();
  for (const x of a) ma.set(x, (ma.get(x) || 0) + 1);
  for (const x of b) mb.set(x, (mb.get(x) || 0) + 1);
  if (ma.size !== mb.size) return false;
  for (const [k, v] of ma) if (mb.get(k) !== v) return false;
  return true;
};

const finishAlbum = async () => {
  try {
    album_loading.value = true;

    // 获取当前页的图片ID和URL的映射关系
    const currentPageImageMap = new Map(
      album_list.map((item) => [item.originAlbumImage, item.albumImageId])
    );

    // 获取当前页编辑后的图片URL数组
    const currentPageDraftUrls = albumDraft.value.map(
      (item) => item.originAlbumImage || item
    );

    // 获取完整的相册数据
    let allAlbumImages = [
      ...(drawerCache.value.activityInfo.albumImages || []),
    ];

    // 创建一个新的数组来存储更新后的图片
    const updatedAllImages = allAlbumImages.filter((imageUrl) => {
      // 如果图片URL在当前页面中，则根据编辑后的内容决定是否保留
      if (currentPageImageMap.has(imageUrl)) {
        return currentPageDraftUrls.includes(imageUrl);
      }
      // 不在当前页面的图片保持不变
      return true;
    });

    // 添加新上传的图片（当前页中原来不存在的图片）
    const newImages = currentPageDraftUrls.filter(
      (imageUrl) => !currentPageImageMap.has(imageUrl)
    );
    updatedAllImages.push(...newImages);

    // 检查是否有实际的变化
    const hasChanges = !isSameArrayIgnoreOrder(
      allAlbumImages,
      updatedAllImages
    );

    if (!hasChanges) {
      img_edit.value = false;
      album_loading.value = false;
      return;
    }

    // 保存完整的相册数据
    await activity_album_save({
      goodsId: selected_act_id.value,
      albumImages: updatedAllImages,
    });

    // 更新缓存
    drawerCache.value.activityInfo.albumImages = updatedAllImages;
    img_edit.value = false;
    ElMessage.success("已保存");
    album_loading.value = false;

    // 重新获取当前页数据以显示最新状态
    getAlbum();
  } catch (err) {
    console.log(err);
    img_edit.value = false;
    album_loading.value = false;
    ElMessage.error("保存失败");
  }
};

const selectTab = (id) => {
  tab_selected.value = id;
};

const collectAlbum = async (item) => {
  try {
    if (img_edit.value) {
      ElMessage.error("请先取消编辑");
      return;
    }
    album_loading.value = true;

    // 找到当前项在 album_list 中的索引
    const albumIndex = album_list.findIndex(
      (albumItem) => albumItem.originAlbumImage === item.originAlbumImage
    );
    if (albumIndex === -1) {
      album_loading.value = false;
      return;
    }

    // 更新本地状态
    album_list[albumIndex].isClubCollected = true;

    await api_collectActivityPhoto({
      albumImageId: album_list[albumIndex].albumImageId,
      storeId: userInfoStore().info.storeId,
      collectionType: "STORE",
    });

    album_loading.value = false;
    ElMessage.success("已收藏");
  } catch (err) {
    console.log(err);
    ElMessage.error("收藏失败");

    // 失败时回滚状态
    const albumIndex = album_list.findIndex(
      (albumItem) => albumItem.originAlbumImage === item.originAlbumImage
    );
    if (albumIndex !== -1) {
      album_list[albumIndex].isClubCollected = false;
    }

    album_loading.value = false;
  }
};

const showCCDialog = async (item) => {
  cancel_albumImageIndex.value = item;
  cancel_collect_show.value = true;
};

const cancelCollectAlbum = async (index) => {
  try {
    if (img_edit.value) {
      ElMessage.error("请先取消编辑");
      return;
    }
    cancel_collect_show.value = false;
    album_loading.value = true;

    // 找到当前项在 album_list 中的索引
    const albumIndex = album_list.findIndex(
      (albumItem) =>
        albumItem.originAlbumImage ===
        cancel_albumImageIndex.value.originAlbumImage
    );
    if (albumIndex === -1) {
      album_loading.value = false;
      return;
    }

    // 更新本地状态
    album_list[albumIndex].isClubCollected = false;

    await api_cancelCollectActivityPhoto({
      albumImageId: album_list[albumIndex].albumImageId,
      storeId: userInfoStore().info.storeId,
    });
    album_loading.value = false;
    ElMessage.success("已取消收藏");
  } catch (err) {
    console.log(err);
    cancel_collect_show.value = false;
    ElMessage.error("取消收藏失败");

    // 失败时回滚状态
    const albumIndex = album_list.findIndex(
      (albumItem) =>
        albumItem.originAlbumImage ===
        cancel_albumImageIndex.value.originAlbumImage
    );
    if (albumIndex !== -1) {
      album_list[albumIndex].isClubCollected = true;
    }

    album_loading.value = false;
  }
};

// 处理分组统计已报名人数
const totalLimit = computed(() => {
  console.log("run in totalLimit==========", totalLimit)
  const list = drawerCache.value?.activityInfo?.activityDivisions || []

  return list.reduce((total, item) => {
    return total + Number(item.registeredCount || 0)
  }, 0)
})

// 处理分组统计报名上限人数
const maxLimit = computed(() => {
  const list = drawerCache.value?.activityInfo?.activityDivisions || []

  return list.reduce((total, item) => {
    return total + Number(item.quotaLimit || 0)
  }, 0)
})
</script>

<template>
  <div class="flex" style="margin-bottom: 22px">
    <v-row justify="center">
      <v-col cols="3">
        <div class="info_item">
          <countTo
            :title="statisticsData.total"
            class="info_item_num txt_overflow"
            :startVal="0"
            :endVal="statisticsData.total"
            :duration="3000"
          ></countTo>
          <div>当前活动总次数</div>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="info_item">
          <countTo
            :title="statisticsData.thisYearTotal"
            class="info_item_num txt_overflow"
            :startVal="0"
            :endVal="statisticsData.thisYearTotal"
            :duration="3000"
          ></countTo>
          <div>今年举办活动次数</div>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="info_item">
          <countTo
            :title="statisticsData.thisMonthTotal"
            class="info_item_num txt_overflow"
            :startVal="0"
            :endVal="statisticsData.thisMonthTotal"
            :duration="3000"
          ></countTo>
          <div>本月举办活动次数</div>
        </div>
      </v-col>
      <v-col cols="3">
        <div class="info_item">
          <div>
            <countTo
              :title="statisticsData.underWayTotal"
              class="info_item_num txt_overflow"
              :startVal="0"
              :endVal="statisticsData.underWayTotal"
              :duration="3000"
            ></countTo>
            <div>正在进行活动</div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
  <div class="new_container_box">
    <div class="table_filter_box flex_bt mg_b_2">
      <div class="table_filter_title flex_left">
        <div style="margin-right: 27px">活动</div>
        <v-btn color="#796CB4" @click="router.push('/store/editActivity')">
          <template v-slot:default>
            <div class="flex_bt">
              <img
                style="width: 14px; height: 14px; margin-right: 4px"
                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
              />
              <span>发布</span>
            </div>
          </template>
        </v-btn>
      </div>
      <div class="flex">
        <el-input
          v-model="formData.name"
          :class="
            formData.name === null || formData.name === ''
              ? 'input-null mg_r_2'
              : 'input-filled mg_r_2'
          "
          style="width: 170px"
          placeholder="活动名称"
        ></el-input>
        <YTAddress
          ref="YTAddressRef"
          :onlySecond="true"
          :placeholder="`活动城市`"
          class="mg_r_2"
          :addressCode="formData.city"
          @select="handleSelectAddress"
          style="width: 170px"
        ></YTAddress>
        <el-select
          :suffix-icon="$SelectArrowDown"
          collapse-tags
          multiple
          :teleported="false"
          v-model="formData.activityStateList"
          :class="
            formData.activityStateList.length === 0
              ? 'input-null'
              : 'input-filled'
          "
          style="width: 170px"
          placeholder="活动状态"
        >
          <el-option
            v-for="item in activityStateOption"
            :key="item.stateId"
            :label="item.stateName"
            :value="item.stateId"
          >
            <template #default>
              <div class="flex_bt">
                <div class="option-label">{{ item.stateName }}</div>
                <img
                  v-if="
                    formData.activityStateList &&
                    formData.activityStateList.includes(item.stateId)
                  "
                  style="width: 13px; height: 13px"
                  src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/selected.svg"
                />
              </div>
            </template>
          </el-option>
        </el-select>
        <v-btn
          style="margin-right: 15px; margin-left: 40px"
          color="#4CAF50"
          @click="handleSearch('btnSearch')"
          >搜索</v-btn
        >
        <v-btn color="#d7d7df" @click="handleReset">重置</v-btn>
      </div>
    </div>
    <div style="margin-bottom: 25px">
      <el-table
        :data="tableData"
        :border="false"
        style="width: 100%"
        :header-row-style="{ color: '#272539' }"
        :row-style="{ color: '#656565' }"
        v-loading="loading"
        stripe
      >
        <el-table-column
          prop="goodsName"
          label="活动名称"
          width="250"
          show-overflow-tooltip
        >
          <template #header="scope">
            <div style="padding-left: 13px">活动名称</div>
          </template>
          <template #default="scope">
            <el-link
              type="default"
              :underline="false"
              style="text-decoration: underline; padding-left: 13px"
              @click="getDetail(scope.row)"
            >
              {{ scope.row.goodsName }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="crTime"
          label="报名时间"
          sortable
          min-width="320"
        >
          <template #default="scope">
            {{
              scope.row.applyStartTime || scope.row.applyEndTime
                ? scope.row.applyStartTime + " - " + scope.row.applyEndTime
                : " - "
            }}
          </template>
        </el-table-column>
        <el-table-column label="活动分组" min-width="120" show-overflow-tooltip>
          <template #default="scope">
            <div v-if="scope.row.storeGroup?.storeGroupName">
              {{ scope.row.storeGroup.storeGroupName }}
            </div>
            <div v-else>—</div>
          </template>
        </el-table-column>
        <el-table-column
          label="活动标签"
          width="200"
          show-overflow-tooltip
          :tooltip-formatter="formatTags"
        >
          <template #default="scope">
            <div v-if="scope.row.tagList.length > 0">
              <YTTag
                v-for="(item, index) in scope.row.tagList"
                class="mg_r_1"
                :key="`tagList${index}`"
                :label="item.tagName"
                :type="'primary'"
              ></YTTag>
            </div>
            <div v-else>—</div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="活动状态">
          <template #default="scope">
            {{
              scope.row.activityState
                ? activityStateOption.find(
                    (i) => i.stateId === scope.row.activityState
                  ).stateName
                : "—"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="活动城市">
          <template #default="scope">
            {{ scope.row.province }}{{ scope.row.city }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="已报名">
          <template #default="scope">
            <div v-if="scope.row.hasDivision">
              {{ scope.row.divisioTotalRegisteredCount }}/{{scope.row.divisionTotalQuotaLimit}}
            </div>
            <div v-else>
              <div v-if="scope.row.inventory">
                {{ scope.row.inventory.lockedQty }}/{{scope.row.inventory.totalQty}}
              </div>
              <div v-else>0</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="费用">
          <template #default="scope">
            <div v-if="scope.row.retailPrice === 0">免费</div>
            <div v-else style="color: #da7a00">
              ￥{{ scope.row.retailPrice }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="" label="相册">
          <template #default="scope">
            {{ scope.row.hasAlbum ? "有" : "无" }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="发布状态">
          <template #default="scope">
            <YTActivityState :state="scope.row.state"></YTActivityState>
          </template>
        </el-table-column>
        <el-table-column prop="control" label="操作" width="120" fixed="right">
          <template #default="scope">
            <div class="flex">
              <el-popconfirm
                @confirm="setSale(scope.row)"
                :title="`发布“${scope.row.goodsName}”`"
              >
                <template #reference>
                  <div>
                    <el-tooltip
                      class="box-item"
                      effect="dark"
                      content="发布"
                      placement="top"
                    >
                      <img
                        v-if="scope.row.state === 0"
                        style="width: 20px; height: 20px; margin-right: 15px"
                        class="cursor-pointer"
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_sale.svg"
                      />
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="#796CB4" @click="confirm"
                      >确定</v-btn
                    >
                  </div>
                </template>
              </el-popconfirm>
              <el-popconfirm
                @confirm="setUnSale(scope.row)"
                :title="`下架“${scope.row.goodsName}”`"
              >
                <template #reference>
                  <div>
                    <el-tooltip
                      class="box-item"
                      effect="dark"
                      content="下架"
                      placement="top"
                    >
                      <img
                        v-if="scope.row.state === 1"
                        style="width: 20px; height: 20px; margin-right: 15px"
                        class="cursor-pointer"
                        src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_unsale.svg"
                      />
                    </el-tooltip>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="#796CB4" @click="confirm"
                      >确定</v-btn
                    >
                  </div>
                </template>
              </el-popconfirm>
              <div
                v-if="scope.row.state === -1"
                style="
                  font-weight: 500;
                  font-size: 13px;
                  color: #be2e48;
                  margin-right: 10px;
                "
              >
                联系客服
              </div>
              <el-tooltip
                class="box-item"
                effect="dark"
                content="编辑"
                placement="top"
                @click.stop
              >
                <img
                  class="cursor-pointer"
                  src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_edit.svg"
                  @click="handleEdit(scope.row)"
                />
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pd_b_4" style="padding-right: 20px">
      <YTTablePagination
        ref="YTTablePaginationRef"
        :pageSize="$globalPageSize"
        :total="total"
        @page-change="handleChangePage"
      ></YTTablePagination>
    </div>
  </div>
  <el-drawer
    :title="`活动详情`"
    v-model="drawer"
    direction="rtl"
    :close="handleCloseDrawer"
    :show-close="false"
    style="text-align: left"
    :size="'100%'"
    stripe
  >
    <template #header="{ close, titleId, titleClass }">
      <div class="flex_left">
        <v-btn
          class="mg_l_1"
          style="margin-right: 7px"
          variant="text"
          icon=""
          @click="handleCloseDrawer"
        >
          <template v-slot:default>
            <el-icon size="20" class="cursor-pointer"><Close /></el-icon>
          </template>
        </v-btn>
        <div :id="titleId" :class="titleClass">
          活动详情{{
            drawerCache.goodsName ? "（" + drawerCache.goodsName + "）" : ""
          }}
        </div>
      </div>
    </template>

    <el-skeleton v-if="drawerLoading" :rows="5" animated />
    <div v-else style="box-sizing: border-box; padding-left: 60px">
      <div>
        <YTCard :title="`更改报名状态：`" :row="true" :mg_b="0">
          <template #container>
            <div style="box-sizing: border-box">
              <div>
                <el-select
                  :disabled="drawerCache.goodsName === null"
                  @change="handleChangeState"
                  :suffix-icon="$SelectArrowDown"
                  :teleported="false"
                  v-model="drawerCache.activityInfo.activityState"
                  :class="
                    drawerCache.activityInfo?.activityState === null ||
                    drawerCache.activityInfo?.activityState === ''
                      ? 'input-null'
                      : 'input-filled'
                  "
                  style="width: 170px"
                  placeholder="活动状态"
                >
                  <el-option
                    v-for="item in activityStateOption"
                    :key="item.stateId"
                    :label="item.stateName"
                    :value="item.stateId"
                  >
                    <template #default>
                      <div class="flex_bt">
                        <div class="option-label">{{ item.stateName }}</div>
                        <img
                          v-if="
                            drawerCache.activityInfo?.activityState &&
                            drawerCache.activityInfo?.activityState ===
                              item.stateId
                          "
                          style="width: 13px; height: 13px"
                          src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/selected.svg"
                        />
                      </div>
                    </template>
                  </el-option>
                </el-select>
              </div>
            </div>
          </template>
        </YTCard>
      </div>
      <div>
        <YTCard :title="`基础信息：`" :mg_b="0">
          <template #container>
            <div
              class="flex_left flex_align_t"
              style="box-sizing: border-box; padding-left: 30px"
            >
              <div>
                <div class="mg_b_1 form_txt_gray">
                  活动名称：{{ drawerCache.goodsName }}
                </div>
                <div class="mg_b_1 form_txt_gray">
                  活动时间：{{
                    drawerCache.activityInfo.startTime ||
                    drawerCache.activityInfo.endTime
                      ? drawerCache.activityInfo.startTime +
                        " - " +
                        drawerCache.activityInfo.endTime
                      : " - "
                  }}
                </div>
              </div>
              <div class="ml150">
                <div class="mg_b_1 form_txt_gray">
                  活动类型：
                  <span v-if="drawerCache.activityInfo.activityType === 'ONLINE'">线上</span>
                  <span v-else-if="drawerCache.activityInfo.activityType === 'OFFLINE'">线下</span>
                  <span v-else>—</span>
                </div>
                <div class="mg_b_1 form_txt_gray">
                  活动城市：
                  <span v-if="drawerCache.activityInfo.isNationwide">
                    全国
                  </span>
                  <span v-else>{{ drawerCache.activityInfo.province
                    }}{{ drawerCache.activityInfo.city
                    }}{{ drawerCache.activityInfo.district
                    }}{{ drawerCache.activityInfo.addressDetail }}</span>
                </div>
              </div>
              <div class="ml150">
                <div class="mg_b_1 form_txt_gray flex_left">
                  <div class="mg_r_2">
                    活动分组：{{
                      drawerCache.storeGroup?.storeGroupName
                          ? drawerCache.storeGroup.storeGroupName
                          : "—"
                    }}
                  </div>
                  <div>
                    活动标签：
                    <span v-if="drawerCache.tagList?.length > 0">
                      <span
                          v-for="(item, index) in drawerCache.tagList"
                          :key="`tagList${index}`"
                      >{{ item.tagName
                        }}<span v-if="index + 1 !== drawerCache.tagList.length"
                        >、</span
                        ></span
                      >
                    </span>
                    <span v-else>—</span>
                  </div>
                </div>
                <div class="flex_left" v-if="drawerCache.activityInfo.activityDivisions.length <= 0">
                  <div class="form_txt_gray mg_r_2">
                    骑行距离：{{
                      drawerCache.activityInfo.cyclingDistance
                          ? drawerCache.activityInfo.cyclingDistance
                          : 0
                    }}km
                  </div>
                  <div class="form_txt_gray">
                    骑行速度：{{
                      drawerCache.activityInfo.cyclingSpeed
                          ? drawerCache.activityInfo.cyclingSpeed
                          : 0
                    }}km/h
                  </div>
                </div>
              </div>
            </div>
          </template>
        </YTCard>
      </div>
      <div>
        <YTCard :title="`报名信息：`" :mg_b="40">
          <template #container>
            <div
              style="box-sizing: border-box; padding-left: 30px; display: flex"
            >
              <div>
                <div class="mg_b_1 form_txt_gray">
                  报名时间：{{
                    drawerCache.activityInfo.applyStartTime ||
                    drawerCache.activityInfo.applyEndTime
                      ? drawerCache.activityInfo.applyStartTime +
                        " - " +
                        drawerCache.activityInfo.applyEndTime
                      : " - "
                  }}
                </div>
                <div class="mg_b_1 form_txt_gray" v-if="drawerCache.activityInfo.activityDivisions.length <= 0">
                  公开范围：{{
                    handleVisibilityType(
                      drawerCache.activityInfo.visibilityType
                    )
                  }}
                </div>
              </div>
              <div class="ml150">
                <div class="mg_b_1 form_txt_gray flex_left">
                  <div class="mg_r_2" v-if="drawerCache.activityInfo.activityDivisions.length > 0">
                    总报名人数：{{totalLimit}}人（人数上限{{maxLimit}}人）
                  </div>
                  <div class="mg_r_2" v-else>
                    已报名人数：{{
                      drawerCache.inventory?.lockedQty
                          ? drawerCache.inventory?.lockedQty
                          : 0
                    }}人（人数上限{{
                      drawerCache.inventory?.totalQty
                          ? drawerCache.inventory?.totalQty
                          : 0
                    }}人）
                  </div>
                  <div class="mg_r_2">待支付{{ drawerCache.unpaidQty }}人</div>
                  <div>已取消{{ drawerCache.cancelledQty }}人</div>
                  <div class="form_txt_gray mg_l_2" v-if="drawerCache.activityInfo.activityDivisions.length > 0">
                    公开范围：{{
                      handleVisibilityType(
                          drawerCache.activityInfo.visibilityType
                      )
                    }}
                  </div>
                </div>
                <div class="mg_b_1 form_txt_gray" v-if="drawerCache.activityInfo.activityDivisions.length <= 0">
                  活动费用：￥{{ Number(drawerCache.retailPrice).toFixed(2) }}
                </div>
              </div>
            </div>
            <div style="box-sizing: border-box" class="mg_b_1 pd_l_3 flex_left flex_align_t" v-if="drawerCache.activityInfo.activityDivisions.length > 0">
              <div class="form_txt_gray">组别信息：</div>
              <div>
                <div class="form_txt_gray flex_left" v-for="(item, index) in drawerCache.activityInfo.activityDivisions" :key="`drawerCache.activityInfo.activityDivisions${index}`">
                  <div class="form_txt_gray mg_r_2">{{ item.divisionName }}</div>
                  <div class="form_txt_gray mg_r_2">原价￥{{ item.originalPrice }}</div>
                  <div class="form_txt_gray mg_r_2">会员价￥{{ item.entryFee }}</div>
                  <div class="form_txt_gray mg_r_2">VIP价￥{{ item.vipEntryFee }}</div>
                  <div class="form_txt_gray mg_r_2">骑行距离{{ item.distance }}km</div>
                  <div class="form_txt_gray mg_r_2">爬升{{ item.elevationGain }}m</div>
                  <div class="form_txt_gray mg_r_2">已报名人数{{ item.registeredCount }}人（人数上限{{item.quotaLimit}}人）</div>
                </div>
              </div>
            </div>
          </template>
        </YTCard>
      </div>
      <!-- <el-divider /> -->

      <!-- tabs页面 -->
      <div class="tabs">
        <YTTab :tab_list="tabs_list" @selected="selectTab">
          <template #button_box>
            <div class="button_box" v-if="tab_selected === 0">
              <v-btn
                :disabled="drawerCache.goodsName === null"
                color="#4CAF50"
                @click="handleDownloadSignedUpActivityUser(drawerCache)"
              >
                下载已报名人员表
              </v-btn>
            </div>
            <div class="button_box" v-if="tab_selected === 2">
              <v-btn
                style="margin-right: 15px; margin-left: 40px"
                color="#d7d7df"
                @click="startAlbumEdit"
                v-if="!img_edit"
              >
                管理
              </v-btn>
              <v-btn
                color="#d7d7df"
                @click="cancel_finishAlbum"
                v-if="img_edit"
              >
                取消
              </v-btn>
              <v-btn
                class="ml10"
                color="#4CAF50"
                @click="finishAlbum"
                v-if="img_edit"
              >
                保存
              </v-btn>
            </div>
          </template>
        </YTTab>
        <div class="tabs_page mt36 pb300">
          <div v-show="tab_selected === 0">
            <div>
              <el-table
                id="drawerTable"
                :data="drawerTableData"
                :border="false"
                style="width: 100%; margin-bottom: 24px"
                height="460"
                :header-row-style="{ color: '#272539' }"
                :row-style="{ color: '#656565' }"
                v-loading="loading"
                stripe
              >
                <el-table-column label="序号" sortable width="100">
                  <template #header>
                    <span style="padding-left: 13px">序号</span>
                  </template>
                  <template #default="scope">
                    <span style="padding-left: 20px">{{
                      scope.$index + 1
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="hasCheckIn" label="是否签到">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{ scope.row.hasCheckIn ? "是" : "否" }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="nickname" label="用户昵称">
                  <template #default="scope">
                    {{ scope.row.nickname ? scope.row.nickname : "—" }}
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.name" label="姓名">
                  <template #default="scope">
                    {{
                      scope.row.personInfo.name
                        ? scope.row.personInfo.name
                        : "—"
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.gender" label="性别">
                  <template #default="scope">
                    <YTGender :gender="scope.row.personInfo.gender"></YTGender>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="personInfo.phone"
                  label="联系电话"
                  width="120"
                >
                  <template #default="scope">
                    {{
                      scope.row.personInfo.phone
                        ? scope.row.personInfo.phone
                        : "—"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                    prop="personInfo.activityDivisions"
                    label="报名分组"
                    width="120"
                >
                  <template #default="scope">
                    <div v-if="scope.row.activityDivisions.length > 0">
                      <div v-for="(item, index) in scope.row.activityDivisions" :key="`scope.row.activityDivisions${index}`">
                        {{item.divisionName}}
                      </div>
                    </div>
                    <div v-else>
                      —
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="crTime"
                  label="报名时间"
                  sortable
                  min-width="200"
                >
                  <template #default="scope">
                    {{ scope.row.orderTime ? scope.row.orderTime : "—" }}
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.grade" label="年级" v-if="userInfo.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.grade ? scope.row.personInfo.grade : "—"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.height" width="100" label="身高(cm)" v-if="userInfo.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.height ? scope.row.personInfo.height : "—"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.weight" label="体重(kg)" v-if="userInfo.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.weight ? scope.row.personInfo.weight : "—"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="personInfo.certificateType"
                  label="证件类型"
                >
                  <template #default="scope">
                    {{
                      certificateType.find(
                        (i) =>
                          i.stateId === scope.row.personInfo.certificateType
                      )
                        ? certificateType.find(
                            (i) =>
                              i.stateId === scope.row.personInfo.certificateType
                          ).stateName
                        : "—"
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="personInfo.certificateNumber"
                  label="证件号码"
                  width="180"
                />
                <el-table-column
                  prop="personInfo.emergencyContact"
                  label="紧急联系人"
                  min-width="150"
                />
                <el-table-column
                  prop="personInfo.emergencyContactPhone"
                  label="紧急联系人电话"
                  min-width="130"
                />
                <el-table-column prop="personInfo.mediaPlatformAccount" label="新媒体平台（账号ID）" min-width="180">
                  <template #default="scope">
                    {{ scope.row.personInfo.mediaPlatformAccount ? scope.row.personInfo.mediaPlatformAccount : "—" }}
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.emergencyContactRelation" label="与报名人关系" v-if="userInfo.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.emergencyContactRelation ? scope.row.personInfo.emergencyContactRelation : "—"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.allergies" label="过敏" v-if="userInfo.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.allergies ? scope.row.personInfo.allergies : "—"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.hasChildPromise" label="童军承诺" v-if="userInfo.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      {{scope.row.personInfo.hasChildPromise ? "是" : "否"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="personInfo.accommodationType" label="住宿登记" v-if="userInfo.hasActivityRegisterExtraInfo">
                  <template #default="scope">
                    <div style="margin-left: 13px">
                      <div v-if="scope.row.personInfo.accommodationType === 'NOT_STAYING'">不留宿</div>
                      <div v-else-if="scope.row.personInfo.accommodationType === 'CAMPING'">露营</div>
                      <div v-else-if="scope.row.personInfo.accommodationType === 'HOTEL'">民宿或酒店</div>
                      <div v-else>—</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="receiverInfo.receiverName" label="收货人">
                  <template #default="scope">
                    <div v-if="scope.row.receiverInfo?.receiverName">
                      {{scope.row.receiverInfo?.receiverName}}
                    </div>
                    <div v-else>
                      —
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="receiverInfo.receiverPhone" label="收货电话">
                  <template #default="scope">
                    <div v-if="scope.row.receiverInfo?.receiverPhone">
                      {{scope.row.receiverInfo?.receiverPhone}}
                    </div>
                    <div v-else>
                      —
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="receiverInfo.receiverAddress" label="收货地址">
                  <template #default="scope">
                    <div v-if="scope.row.receiverInfo?.receiverAddress">
                      {{scope.row.receiverInfo?.receiverAddress}}
                    </div>
                    <div v-else>
                      —
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注">
                  <template #default="scope">
                    {{ scope.row.remark ? scope.row.remark : "—" }}
                  </template>
                </el-table-column>
                <el-table-column label="报名状态" width="120" fixed="right">
                  <template #header>
                    <el-popover
                      placement="bottom"
                      :width="200"
                      trigger="click"
                      append-to="#drawerTable"
                    >
                      <template #reference>
                        <div id="header_state">
                          <div class="flex">
                            <div style="margin-right: 15px">报名状态</div>
                            <img
                              class="cursor-pointer"
                              src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/select-arrowDown.svg"
                            />
                          </div>
                        </div>
                      </template>
                      <template #default>
                        <div class="select_box">
                          <div
                            class="select_opt txt_overflow flex_bt"
                            v-for="(item, index) in activityState"
                            :key="`activityState${index}`"
                            @click="handleSelectSignStateFilter(item)"
                          >
                            <div
                              :class="
                                selectedIds.includes(item.stateId)
                                  ? 'select_active'
                                  : ''
                              "
                            >
                              {{ item.stateName }}
                            </div>
                            <img
                              v-if="selectedIds.includes(item.stateId)"
                              style="width: 13px; height: 13px"
                              src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/selected.svg"
                            />
                          </div>
                        </div>
                      </template>
                    </el-popover>
                  </template>
                  <template #default="scope">
                    <YTActivitySignOrderState
                      v-if="!drawerLoading"
                      class="mg_r_2"
                      :state="scope.row.orderState"
                    ></YTActivitySignOrderState>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pd_b_3" style="padding-right: 20px">
              <YTTablePagination
                ref="YTTablePaginationDrawerRef"
                :pageSize="$globalPageSize"
                :total="totalDrawer"
                @page-change="handleDrawerPageChange"
              ></YTTablePagination>
            </div>
          </div>
          <div class="ml56" v-show="tab_selected === 1">
            <div class="flex_left flex_align_t">
              <div style="margin-right: 33px">
                <div class="mg_b_1 form_txt_gray">活动封面图：</div>
                <div>
                  <el-image
                    style="width: 140px; height: 140px; border-radius: 15px"
                    :src="drawerCache.images[0]"
                    :zoom-rate="1.2"
                    :max-scale="7"
                    :min-scale="0.2"
                    :preview-src-list="drawerCache.images"
                    show-progress
                    fit="cover"
                  >
                    <template #error>
                      <div class="image-slot">
                        <img
                          style="width: 140px; height: 140px"
                          src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/img_loading_error.svg"
                        />
                      </div>
                    </template>
                  </el-image>
                </div>
              </div>
              <div style="flex: 1">
                <div class="mg_b_1 form_txt_gray">活动描述：</div>
                <div
                  class="ql-editor description_box"
                  v-html="drawerCache.description"
                ></div>
              </div>
            </div>
          </div>
          <div
            class="ml56 pt10"
            v-show="tab_selected === 2"
            v-loading="album_loading"
          >
            <div class="view_statistics fwb">
              相册浏览量：{{ drawerCache?.viewStat?.totalPv }}
            </div>
            <div class="img_box mt20">
              <div class="img_upload_info">
                <BoxUpload
                  :limit="1500"
                  :fileSize="20"
                  :prePath="'album/'"
                  :baseUrl="'/upload/uploadImgs'"
                  :isReplaceMode="false"
                  :showFileList="false"
                  :cache_type="false"
                  @success="handlePicSuccess"
                  @progress="handlePicProgress"
                  @fail="handlePicFail"
                  @remove="handlePicFail"
                ></BoxUpload>
              </div>
              <div class="img_list ml20">
                <div
                  class="img_item ml20 mb20"
                  v-for="(item, index) in img_edit ? albumDraft : album_list"
                  :key="item"
                  @click="showPreview(item)"
                >
                  <div style="position: relative">
                    <img
                      v-if="img_edit"
                      class="del"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/club/img_del.svg"
                      alt=""
                      @click.stop="deleteAlbumImage(item)"
                    />
                    <img
                      class="image"
                      :src="item.thumbnailAlbumImage_20"
                      alt=""
                    />
                    <img
                      v-if="!getAlbumImageInfo(item).isClubCollected"
                      class="collect"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/collect.svg"
                      alt=""
                      @click.stop="collectAlbum(item)"
                    />
                    <img
                      v-if="getAlbumImageInfo(item).isClubCollected"
                      class="collected"
                      src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/collected.svg"
                      alt=""
                      @click.stop="showCCDialog(item)"
                    />
                  </div>
                  <div class="collect_count">
                    {{ shortNumberFormat(item.collectionCount) }}人点赞
                  </div>
                </div>
              </div>
            </div>
            <!-- 分页组件 -->
            <YTTablePagination
              v-if="album_total > 0"
              ref="albumPaginationRef"
              :pageSize="album_params.page_params.pageSize"
              :total="album_total"
              @page-change="handleAlbumPageChange"
            />
            <el-dialog v-model="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="Preview Image" />
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>

  <!-- 取消收藏二次确认弹窗 -->
  <YTDialog
    :open="cancel_collect_show"
    text="确认要取消收藏吗？"
    title="取消收藏"
    @confirm="cancelCollectAlbum"
    @cancel="cancel_collect_show = false"
  ></YTDialog>
</template>

<style lang="scss" scoped>
::v-deep(.ytCard_title) {
  font-weight: 500 !important;
  font-size: 17px !important;
  color: #272539 !important;
}
.form_txt_gray {
  font-weight: 500;
  font-size: 14px;
  color: #6f717d;
}
.drawer_table_filter_title {
  font-weight: 500;
  font-size: 17px;
  color: #272539;
}
::v-deep(.el-popover) {
  width: 170px !important;
  min-height: 40px !important;
  background: #ffffff !important;
  box-shadow: 0 1px 5px 0 rgba(25, 24, 27, 0.22) !important;
  border-radius: 12px;
  padding: 6px 0 !important;
}
.select_box {
  .select_opt {
    width: 100%;
    height: 37px;
    box-sizing: border-box;
    padding: 0 30px;
    cursor: pointer;
    line-height: 37px;
    border-bottom: 1px solid #ececf4;
    font-weight: 400;
    font-size: 14px;
    color: #4d4d4d;
    .select_active {
      color: #796cb4;
      font-weight: 500;
      font-size: 14px;
    }
  }
  .select_opt:last-child {
    border-bottom: none;
  }
  .select_opt:hover {
    background-color: #f5f7fa;
  }
}
.description_box {
  width: 100%;
  min-height: 150px;
  background: #ffffff;
  border-radius: 9px;
  border: 1px solid #796cb4;
  box-sizing: border-box;
  padding: 10px;
}

.tabs {
  .tabs_page {
    .view_statistics {
      font-size: 18px;
      color: #213547;
    }
    .img_box {
      display: flex;
      align-items: flex-start;
      .img_upload_info {
      }
      .img_list {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        .img_item_upload {
          border: none !important;
        }
        .img_item {
          position: relative;
          .del {
            width: 30px;
            height: 30px;

            position: absolute;
            top: -10px;
            right: -10px;
          }

          .image {
            width: 100px;
            height: 100px;
            object-fit: cover;
            object-position: center;
            background: #f6f6f6;
            border-radius: 20px;
            border: 1px solid rgba(0, 0, 0, 0.1);
          }
          .collect_count {
            border-radius: 25px;
            color: #213547;
            font-size: 12px;
            text-align: center;
          }
          .collect,
          .collected {
            width: 33px;
            height: 26px;

            position: absolute;
            bottom: 7px;
            right: 1px;
          }
        }
      }
    }
  }
}

// el-tabs
::v-deep(.el-tabs__item) {
  color: #999999;
  border-radius: 0 5px 0 0;
  width: 150px;
  padding: 0 20px !important;
  background-color: #f6f6f6;
}
::v-deep(.el-tabs__item.is-active) {
  color: #796cb4;
  background: linear-gradient(270deg, #eeeff6 0%, #f5f7fb 43%, #ffffff 100%);
  border-bottom: 2px solid #efefef;
}
::v-deep(.el-tabs__active-bar.is-top) {
  background-color: #796cb4;
}
</style>
